import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const contactApi = createApi({
    reducerPath: 'contactApi',
    baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_BASE_URL }),
    endpoints: (builder) => ({
        submitContactForm: builder.mutation({
            query: (formData) => ({
                url: '/api/contact',
                method: 'POST',
                body: formData,
            }),
        }),
    }),
});

export const { useSubmitContactFormMutation } = contactApi;
